(() => {
  const loader = document.currentScript;
  const menu = document.getElementById('siteNav');
  if (!menu || !loader?.dataset.menuUrl) return;
  let pending;
  const load = event => {
    const item = event.target.closest('.lvl1');
    if (!item || !menu.contains(item) || !item.querySelector('[data-menu-products]:not([data-menu-loaded])')) return;
    if (pending) return;
    pending = fetch(loader.dataset.menuUrl, { credentials: 'same-origin' })
      .then(response => {
        if (!response.ok) throw new Error('Navigation request failed');
        return response.text();
      })
      .then(html => {
        const response = new DOMParser().parseFromString(html, 'text/html');
        const sources = new Map(Array.from(response.querySelectorAll('[data-menu-products]'), slot => [slot.dataset.menuProducts, slot]));
        let loaded = 0;
        menu.querySelectorAll('[data-menu-products]').forEach(slot => {
          const source = sources.get(slot.dataset.menuProducts);
          if (!source) return;
          slot.replaceChildren(...Array.from(source.childNodes, node => document.importNode(node, true)));
          slot.dataset.menuLoaded = 'true';
          loaded++;
        });
        if (!loaded) throw new Error('Navigation content unavailable');
        menu.removeEventListener('pointerover', load);
        menu.removeEventListener('focusin', load);
      })
      .catch(() => { pending = undefined; });
  };
  menu.addEventListener('pointerover', load);
  menu.addEventListener('focusin', load);
})();
